import { createAsyncThunk } from "@reduxjs/toolkit";
import locationsApi from "./api";

export const getLocationsList = createAsyncThunk(
  "locations/getList/loading",
  async (params) => {
    const result = await locationsApi.getLocationsList(params);
    return result;
  }
);

export const getLocationById = createAsyncThunk(
  "locations/getById/loading",
  async (locationId) => {
    const result = await locationsApi.getLocationById(locationId);
    return result;
  }
);

export const updateLocation = createAsyncThunk(
  "locations/update/loading",
  async (data) => {
    return locationsApi.updateLocation(data);
  }
);
